var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about CommonContentSingle-white"},[_c('User_personal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }